<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/projects' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('new') }} {{ $t('project') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
            <div class="row">
                <span class="label">{{ $t('project') }}</span>
                <div class="inputs">
                    <heim-input :label="$t('customer') + ' *'" name="name" :placeholder="$t('customer')" v-model="name" v-validate="'required'"></heim-input>
                     <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
                    <heim-select
                        :label="$t('techno')"
                        :data="types"
                        label-key="type"
                        value-key="id"
                        v-model="type_id"
                    ></heim-select>
                    <heim-textarea :label="$t('description') + ' *'" name="description" :placeholder="$t('description')" v-model="description" v-validate="'required'"></heim-textarea>
                    <span v-show="errors.has('description')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('description') }}</span>
                    <heim-input :label="$t('title') + ' *'" name="title" :placeholder="$t('title')" v-model="title" v-validate="'required|max:25'"></heim-input>
                    <span v-show="errors.has('title')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('title') }}</span>
                    <div class="heim-input">
                    <datepicker 
                        :label="$t('creationDate')"
                        type="date"
                        name="date"
                        input-class="paper-input"
                        wrapper-class="date-input"
                        v-model="date"
                        :placeholder="$t('selectDate')"
                        ></datepicker>
                    </div>
                    <heim-select
                        :label="$t('manager')"
                        :data="users"
                        label-key="name"
                        value-key="id"
                        v-model="user_id"
                    ></heim-select>
                    <heim-input :label="$t('projectMantis')" name="mantis_id" :placeholder="$t('projectMantis')" v-model="mantis_id" type="number"></heim-input>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('status') }}</span>
                <div class="inputs">
                    <heim-select2
                        :label="$t('status')"
                        :data="status"
                        label-key="name"
                        value-key="id"
                        v-model="status_id"
                    ></heim-select2>
                    <heim-input
                        :label="$t('quoteNumber')"
                        name="quote"
                        v-model="quote"
                    ></heim-input>
                    <heim-input
                      :label="$t('amountTotal')"
                      name="amount"
                      type="number"
                      step="0.01"
                      v-model="amount"> </heim-input>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('benefits') }}</span>
                <div class="inputs">
                    <heim-select2
                        :label="$t('benefits')"
                        :data="benefits"
                        label-key="name"
                        value-key="id"
                        v-model="benefit_id"
                    ></heim-select2>
                    <heim-input
                        :label="$t('numberDay')"
                        name="days"
                        type="number"
                        v-model="days"
                        step="0.01"
                    ></heim-input>
                    <heim-input
                        :label="$t('forecastedWorkload')"
                        name="forecasted_workload"
                        type="number"
                        v-model="forecasted_workload"
                        step="0.01"
                    ></heim-input>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ $t('comment') }}</span>
                <div class="inputs">
                    <heim-textarea
                        name="comment"
                        type="text"
                        v-model="comment"
                    ></heim-textarea>
                </div>
            </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimSelect2 from "@/components/form/input/select/heim-select2.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";

import { mapState } from "vuex";
export default {
  name: "ProjectsNew",
  components: {
    HeimInput,
    HeimTextarea,
    HeimSelect,
    HeimSelect2,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker
  },
  mounted() {
    this.$store.dispatch("getBenefits");
    this.$store.dispatch("getUsers");
    this.$store.dispatch("getStatus");
    this.$store.dispatch("getTypes");
    this.$store.dispatch("setTitle", "Create project");
  },
  data() {
    return {
      name: "",
      type_id: "",
      description: "",
      title: "",
      date: "",
      mantis_id: "",
      status_id: "",
      user_id: "",
      quote: "",
      amount: "",
      benefit_id: "",
      days: "",
      forecasted_workload: "",
      comment: ""
    };
  },
  computed: {
    ...mapState({
      users: state => state.projectsState.users,
      benefits: state => state.projectsState.benefits,
      status: state => state.projectsState.status,
      types: state => state.projectsState.types
    })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createProject", {
        type_id: this.type_id,
        description: this.description,
        name: this.name,
        title: this.title,
        date: this.date,
        mantis_id: this.mantis_id,
        status_id: this.status_id,
        user_id: this.user_id,
        quote: this.quote,
        amount: this.amount,
        benefit_id: this.benefit_id,
        days: this.days,
        forecasted_workload: this.forecasted_workload,
        comment: this.comment
      });
      this.$validator.validateAll().then(result => {
        if (result && data.id) {
          this.$store.dispatch("setToastMessage", {
            message: "newProjectcreated"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/projects/${data.id}/details` });
        }
      });
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
</style>
